import React, {useState, useEffect, useContext} from 'react'
import AuthContext from '../../context/AuthContext'
import { Link } from 'react-router-dom'

const Register = () => {
    let {registerUser} = useContext(AuthContext)
    useEffect(() => {
      document.title = "Sign Up | WillowBMS"
    }, [])
    return (
        <div className="page page-center">
      <div className="container-tight py-4">
        <div className="text-center mb-4">
          <a href="."><img src="./static/logo.svg" height="36" alt=""/></a>
        </div>
        <form onSubmit={registerUser} className="card card-md">
          <div className="card-body">
            <h2 className="card-title text-center mb-4">Create new account</h2>
            <div className="mb-3">
              <label className="form-label">First Name</label>
              <input type="text" name="first_name" className="form-control" placeholder="Enter first name"/>
            </div>
            <div className="mb-3">
              <label className="form-label">Last Name</label>
              <input type="text" name="last_name" className="form-control" placeholder="Enter last name"/>
            </div>
            <div className="mb-3">
              <label className="form-label">Username</label>
              <input type="text" name="username" className="form-control" placeholder="Enter username"/>
            </div>
            <div className="mb-3">
              <label className="form-label">Email address</label>
              <input type="email" name="email" className="form-control" placeholder="Enter email"/>
            </div>
            <div className="mb-3">
              <label className="form-label">Password</label>
              <div className="input-group input-group-flat">
                <input type="password" name="password" className="form-control"  placeholder="Password"  autoComplete="off"/>
                <span className="input-group-text">
                  <a href="#" className="link-secondary" title="Show password" data-bs-toggle="tooltip">
                    <svg xmlns="http://www.w3.org/2000/svg" className="icon" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><circle cx="12" cy="12" r="2" /><path d="M22 12c-2.667 4.667 -6 7 -10 7s-7.333 -2.333 -10 -7c2.667 -4.667 6 -7 10 -7s7.333 2.333 10 7" /></svg>
                  </a>
                </span>
              </div>
            </div>
            <div className="mb-3">
              <label>
                <span className="form-check-label">By signing up you are agreeing to the <a href="./terms-of-service.html" tabIndex="-1">Policies and Terms of Service</a> of this site.</span>
              </label>
            </div>
            <div className="form-footer">
              <button type="submit" className="btn btn-primary w-100">Create new account</button>
            </div>
          </div>
        </form>
        <div className="text-center text-muted mt-3">
          Already have account? <Link to="/login" tabIndex="-1"> Sign in </Link>
        </div>
      </div>
      <script src="./dist/js/tabler.min.js"></script>
    </div>
    )
}

export default Register